export default __webpack_public_path__ + "static/media/Gemma of Restoration.9c8cd3f8.jpg";